import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
// services
import { LoginService } from '../../../shared/services/login.service';
import { CopyService } from '../../../shared/services/app-copy.service';
// models
import { AppState } from '../../../booking/models/app-state.interface';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UPDATE_REDIRECT, UPDATE_USER_EMAIL, UPDATE_USER_STATUS } from '@shared/reducers/user.reducer';

@Component({
  selector: 'app-verify-email',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss'],
  providers: [
    LoginService
  ]
})
export class VerifyEmailComponent implements OnInit, OnDestroy {

  private _verifyEmailSubscription: Subscription;
  private _routeParamsSubscription: Subscription;
  private _userLanguageSubscription: Subscription;
  private _bookingInitSubscription: Subscription;

  public emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  public showEmailLoader: Boolean = false;
  public userEmail;
  public userNotFound: Boolean = false;
  public showLoader: Boolean = false;
  public appCopy;
  public copyLoaded: Boolean = false;
  public selectedLanguage = '';

  constructor(
    private _appStore: Store<AppState>,
    private _loginService: LoginService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _copyService: CopyService,
  ) { }

  ngOnInit() {
    this._userLanguageSubscription = this._appStore.select('copyReducer')
    .subscribe((res: any) => {
    this.selectedLanguage = res.language
    })

    this._copyService.getStaticCopy()
      this._bookingInitSubscription = this._appStore.select('loadedStatusReducer')
        .subscribe((res: any) => {
          this.copyLoaded = res.copyLoaded;
            if (res.copyLoaded) {
              this.getCopy();
            }

        })

    // subscribe to router query string
    this._routeParamsSubscription = this._activatedRoute.queryParams
      .subscribe((params: any) => {
        if (typeof params.redirect !== 'undefined') {
          const data = { path: params.redirect, ref: params.ref};
          this._appStore.dispatch(UPDATE_REDIRECT({ redirect: data }));
        }
      },
      err => console.log(err));

    this._verifyEmailSubscription = this._loginService.validateUserSubject$
      .subscribe(res => {

        this._appStore.dispatch(UPDATE_USER_STATUS({ userStatus: res.verifyCustomerStatus }));

        // response codes
        // Active = 1, Inactive = 2, NotFound = 3
        if (res.verifyCustomerStatus === 1) {
          // full user
          this.showEmailLoader = false;
          this._appStore.dispatch(UPDATE_USER_EMAIL({ userEmail: this.userEmail }));
          this._router.navigate(['access-account']);
        } else if (res.verifyCustomerStatus === 2) {
          // user active, no password - send to validate
          this._appStore.dispatch(UPDATE_USER_EMAIL({userEmail: this.userEmail }));
          this._router.navigate(['validate-email']);
        } else if (res.verifyCustomerStatus === 3) {
          // new user
          this.userNotFound = true;
          this.showLoader = false;
        }
      });
  }

  getCopy() {
    const panelHeaderCopy = this._copyService.getCopyBySection(
      'OTHER',
      'login',
      ['loginScreen']
    );
    // console.log(panelHeaderCopy)
    this.appCopy = {
      panelHeader: panelHeaderCopy[0],
    };

  }

  handleSubmitEmailCheck(value, e) {
    e.preventDefault();
    this.showLoader = true;
    this.userEmail = value.email;
    this._loginService.validateEmail(this.userEmail);
  }

  goToRegister() {
    this._router.navigate(['register']);
  }

  ngOnDestroy() {
    this._verifyEmailSubscription.unsubscribe();
    this._routeParamsSubscription.unsubscribe();
    this._userLanguageSubscription.unsubscribe();
    this._bookingInitSubscription.unsubscribe();
  }

}
